import { Outlet } from 'react-router-dom';

export const VendorManagement = () => {
  return <Outlet />;
};
